(function () {
    "use strict";

    var SubReportBlockHeaderControl = Solovis.defineClass(
        "Solovis.Reports.Parts.SubReportBlockHeaderControl",
        Solovis.Reports.Parts.PartControl,
        function (options) {
            var self = this;
            
            this.subReportElementName = options.settings.subReportElementName;
            this._customTitle = options.settings.customTitle ? options.settings.customTitle : null;
        });

    SubReportBlockHeaderControl.prototype.doInit = function () {
        var self = this;
   
        this._registerForSubReportChanges();
    };

    SubReportBlockHeaderControl.prototype.doRender = function () {
        var self = this;

        if (!this._header) {
            var optionDiv = $("<div>").appendTo(this.container)
                .css("padding-right", "10px")
                .css("float", "right");

            var optionLink = $("<a>").html("<span class='fa fa-gear' />").appendTo(optionDiv);

            optionLink.click(function () {
                var subReportPartControl = self.reportControl.getReportPartControl(self.subReportElementName);
                if (subReportPartControl) {
                    var subReportControl = subReportPartControl.subReportControl;
                    if (subReportControl) {
                        subReportControl.showReportOptionsMenu({
                            optionsElement: optionLink
                        });
                    }
                }
            });

            this._header = $("<h3>").html("&nbsp;").appendTo(this.container);

            Solovis.Site.DragDropManager.setupSolovisReportControlDrag(
                optionLink,
                function () {                    
                    var subReportPartControl = self.reportControl.getReportPartControl(self.subReportElementName);                    
                    if (subReportPartControl) {                        
                        return subReportPartControl.subReportControl;
                    }

                    return null;
                });
        }        
    };

    SubReportBlockHeaderControl.prototype.doDestroy = function () {        
    };

    SubReportBlockHeaderControl.prototype._registerForSubReportChanges = function () {
        var self = this;
        var intervalHandle = null;
        var retriesLeft = 100;

        var checkForSubReportPartControl = function () {            
            var subReportPartControl = self.reportControl.getReportPartControl(self.subReportElementName);
            if (subReportPartControl) {                
                if (intervalHandle) {
                    clearInterval(intervalHandle);
                    intervalHandle = null;
                }

                self._subReportPartControl = subReportPartControl;

                var handleChangeEventsOnSubReportControl = function (subReportControl) {
                    try {
                        // Bind to reportDataLoaded event, so we can refresh title in cases of dynamic title changes.
                        $(subReportControl).bind("reportDataLoaded", function () {
                            self._updateTitle();
                        });
                        // Bind to reportDataLoaded event, so we can refresh title after the initialization to get preliminary title.
                        $(subReportControl).bind("initComplete", function () {
                            self._updateTitle();
                        });
                        self._updateTitle();
                    }
                    catch (ex) {
                        console.log("SubReportBlockHeaderControl._updateTitle failed");
                        console.log(ex);
                    }
                };

                $(subReportPartControl).bind("subReportControlChanged", function () {
                    handleChangeEventsOnSubReportControl(subReportPartControl.subReportControl);
                });

                if (subReportPartControl.subReportControl) {
                    handleChangeEventsOnSubReportControl(subReportPartControl.subReportControl);
                    self._updateTitle();
                }
            }
            else {
                retriesLeft--;

                if (retriesLeft <= 0) {
                    if (intervalHandle) {
                        console.log("SubReportBlockHeaderControl._registerForSubReportChanges: unable to find sub-report part control: " + self.subReportElementName);

                        clearInterval(intervalHandle);
                        intervalHandle = null;
                    }
                }
            }
        };

        checkForSubReportPartControl();
        if (!this._subReportPartControl) {
            // Wait for the sub-report part to show up.
            intervalHandle = setInterval(checkForSubReportPartControl, 10);
        }        
    };

    SubReportBlockHeaderControl.prototype._updateTitle = function () {        
        try {
            var subReportPartControl = this.reportControl.getReportPartControl(this.subReportElementName);
            if (subReportPartControl) {
                var title = subReportPartControl.getSubReportTitle();
                if (!title) {
                    title = "";
                }

                if (this._customTitle && subReportPartControl.subReportControl) {
                    title = this._customTitle(subReportPartControl.subReportControl);
                }

                if (this._header) {
                    if (title) {
                        this._header.text(title);
                    }
                    else {                        
                        this._header.html("&nbsp;");
                    }
                }
            }
        }
        catch (ex) {
            console.log("SubReportBlockHeaderControl._updateTitle failed");
            console.log(ex);
        }
    };

})();